/** @see $bog_builderui_tokens */
namespace $ {
	$mol_style_define( $bog_builderui_skeleton, {
		minHeight: '1rem',
	} )
}
